import React from 'react';
import styles from './home.module.css'
import background from '../../assets/6.png'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-scroll';

function Home() {

  const { t } = useTranslation();


  return (
    <div className={styles.home} id='home'>
      <div className={styles.blur}></div>
      <img src={background} className={styles.background} />
      <div className={styles.left}>
        <div className={styles.parent}>
          <tr></tr>
          <h1>{t('welcome')}</h1>
          <p>{t("desc")}</p>
          <Link to="contact" smooth={true} duration={500} offset={-80}>
            <button className={styles.ctaButton}>{t('heroCta')}</button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Home;
